export default __webpack_public_path__ + "static/media/Slide-1.4905f0f7.jpg";